import { getPublicRouteUrl } from '@nackle/service-urls';

let tempEnv = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'localhost', 'qa', 'pprd', 'ci' ].indexOf( chunk ) >= 0;
} );

if ( tempEnv === 'localhost' ) {
    tempEnv = 'qa';
}

export const env = tempEnv;

export function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}


export const idURL = getPublicRouteUrl( 'ID_PROVIDER' );
export const companyURL = getPublicRouteUrl( 'COMPANY_SETUP' );
export const companiesURL = getPublicRouteUrl( 'COMPANY_SERVICE' );
export const saURL = getPublicRouteUrl( 'SERVICE_AWARDS' );
export const emailURL = getPublicRouteUrl( 'EMAIL_SERVICE_SERVICE_V1' );
export const giftCodeURL = getPublicRouteUrl( 'GIFT_CODE' );
export const companyAdminURL = getURL( 'https://(env.)company-studio.biw.cloud' );
export const giftCodeAdminURL = getURL( 'https://(env.)gift-codes.biw.cloud' );
export const dataAdminURL = getURL( 'https://(env.)service-awards-data-admin.biw.cloud' );
export const imagesUrl = `${ getPublicRouteUrl( 'IMAGES' ) }/`;
export const rosterUrl = getPublicRouteUrl( 'ROSTER_PROXY' );
export const videoUrl = `${ getPublicRouteUrl( 'MTC_INGEST' ) }/v1/upload-video`;
export const cmxUrl = getPublicRouteUrl( 'CMX_SERVICE_V2' );
export const cashierUrl = getPublicRouteUrl( 'CASHIER' );
export const solutionsUrl = `${ getPublicRouteUrl( 'SOLUTION_API' ) }/services/v1`;
export const experienceRegistryUrl = getPublicRouteUrl( 'EXPERIENCE_REGISTRY_API' );
export const rosterGroupsUrl = getURL( 'https://(env.)roster-groups.biw.cloud' );
export const brandingHatchUrl = getURL( 'https://(env.)branding-hatch.biw.cloud' );
export const cypherUrl = getPublicRouteUrl( 'CYPHER' );

